import cx from "classnames";
import { parseTextAlignAttr } from "../base/helpers";
export const headingNodes = {
    heading: {
        attrs: {
            level: { default: 1 },
            id: { default: "" },
            collapse: { default: false },
            textAlign: { default: null },
            indentation: { default: 0 },
        },
        content: "inline*",
        group: "block",
        defining: true,
        parseDOM: [
            { tag: "h1", getAttrs: parseHeadingAttrs(1) },
            { tag: "h2", getAttrs: parseHeadingAttrs(2) },
            { tag: "h3", getAttrs: parseHeadingAttrs(3) },
            { tag: "h4", getAttrs: parseHeadingAttrs(4) },
            { tag: "h5", getAttrs: parseHeadingAttrs(5) },
            { tag: "h6", getAttrs: parseHeadingAttrs(6) },
        ],
        toDOM(node) {
            const attrs = node.attrs;
            return [`h${attrs.level}`, getHeadingDomAttrs(attrs), 0];
        },
    },
};
export function getHeadingDomAttrs(attrs) {
    const { id, indentation, collapse, textAlign } = attrs;
    return {
        class: cx("heading", {
            collapse,
            [`align-${textAlign}`]: textAlign,
        }),
        "data-id": id,
        "data-indentation": `${indentation}`,
        "data-collapse": collapse ? "true" : "false",
    };
}
export function parseHeadingAttrs(level) {
    return (element) => ({
        level,
        id: element.getAttribute("data-id"),
        collapse: element.getAttribute("data-collapse") === "true",
        indentation: parseInt(element.getAttribute("data-indentation"), 10),
        textAlign: parseTextAlignAttr(element),
    });
}
